<template>
  <div class="login-page d-flex justify-content-center">
    <div class="card shadow" style="border-radius: 0.75rem">
      <div class="card-body login-card-body" style="border-radius: 0.75rem">
        <div class="mb-4">
          <div class="pt-3 mb-3">
            <h3 class="mb-0 font-weight-bold text-dark">Register</h3>
            <router-link
              :to="{ name: 'Login' }"
              class="text-decoration-none text-secondary"
              >Have a Account ? <span class="text-primary">Login</span>
            </router-link>

            <ul class="px-0 mb-0" style="list-style-type: none">
              <li v-if="errorMessage.username" class="text-danger">
                <small>
                  {{ errorMessage.username[0] }}
                </small>
              </li>
              <li v-if="errorMessage.email" class="text-danger">
                <small>
                  {{ errorMessage.email[0] }}
                </small>
              </li>
            </ul>

            <p v-if="successMessage">
              <small class="text-success">
                {{ successMessage }}
                <a href="#" @click="resendVerification(resendId)"
                  >Resend Email verification</a
                >
              </small>
            </p>
          </div>
        </div>
        <form @submit.prevent="register()">
          <div class="mb-3">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                :class="{ 'border-danger': $v.payload.name.$error }"
                placeholder="Name"
                v-model="payload.name"
              />
              <div class="input-group-append">
                <div
                  class="input-group-text"
                  :class="{ 'border-danger': $v.payload.name.$error }"
                >
                  <span class="fas fa-user"></span>
                </div>
              </div>
            </div>
            <div class="text-danger" v-if="$v.payload.name.$error">
              <small>Name Required</small>
            </div>
          </div>
          <div class="mb-3">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                :class="{ 'border-danger': $v.payload.username.$error }"
                placeholder="Username"
                v-model="payload.username"
              />
              <div class="input-group-append">
                <div
                  class="input-group-text"
                  :class="{ 'border-danger': $v.payload.username.$error }"
                >
                  <span class="fas fa-user"></span>
                </div>
              </div>
            </div>
            <div class="text-danger" v-if="$v.payload.username.$error">
              <small>Username Required</small>
            </div>
          </div>
          <div class="mb-3">
            <div class="input-group">
              <input
                type="email"
                class="form-control"
                :class="{
                  'border-danger':
                    $v.payload.email.$error || !$v.payload.email.email,
                }"
                placeholder="Email"
                v-model="payload.email"
              />
              <div class="input-group-append">
                <div
                  class="input-group-text"
                  :class="{
                    'border-danger':
                      $v.payload.email.$error || !$v.payload.email.email,
                  }"
                >
                  <span class="fas fa-envelope"></span>
                </div>
              </div>
            </div>
            <div
              class="text-danger"
              v-if="$v.payload.email.$error && !$v.payload.email.required"
            >
              <small>Email Required</small>
            </div>
            <div class="text-danger" v-else-if="!$v.payload.email.email">
              <small>This Field must be an Email</small>
            </div>
          </div>
          <div class="mb-3">
            <div class="form-group">
              <vue-tel-input
                v-model="payload.phone"
                :autoDefaultCountry="false"
                defaultCountry="id"
                @validate="validatePhone"
                @country-changed="countryChanged"
                @input="
                  validateFirstLetter();
                  phoneFirstTimeLoad++;
                "
                :class="{
                  'border-danger':
                    (!phoneValid ||
                      !$v.payload.phone.required ||
                      !$v.payload.phone.checkData) &&
                    phoneFirstTimeLoad > 3,
                }"
              ></vue-tel-input>
              <div
                class="text-danger"
                v-if="
                  (!phoneValid || !$v.payload.phone.checkData) &&
                  phoneFirstTimeLoad > 3
                "
              >
                <small>Phone Number is invalid</small>
              </div>
              <div class="text-danger" v-if="!$v.payload.phone.required">
                <small>Phone Required</small>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="input-group">
              <input
                :type="show.password ? 'text' : 'password'"
                class="form-control"
                :class="{ 'border-danger': $v.payload.password.$error }"
                placeholder="Password"
                v-model="payload.password"
              />
              <div class="input-group-append">
                <div
                  class="input-group-text"
                  :class="{ 'border-danger': $v.payload.password.$error }"
                  @click="showPassword()"
                >
                  <span
                    class="fas"
                    :class="{
                      'fa-eye': !show.password,
                      'fa-eye-slash': show.password,
                    }"
                  ></span>
                </div>
              </div>
            </div>
            <div class="text-danger" v-if="$v.payload.password.$error">
              <small>Password Required</small>
            </div>
          </div>
          <div class="mb-3">
            <div class="input-group">
              <input
                :type="show.confirm_password ? 'text' : 'password'"
                class="form-control"
                :class="{
                  'border-danger':
                    $v.payload.confirm_password.$error ||
                    !$v.payload.confirm_password.sameAsPassword,
                }"
                placeholder="Password Confirmation"
                v-model="payload.confirm_password"
              />
              <div class="input-group-append">
                <div
                  class="input-group-text"
                  :class="{
                    'border-danger':
                      $v.payload.confirm_password.$error ||
                      !$v.payload.confirm_password.sameAsPassword,
                  }"
                  @click="showConfirmPassword()"
                >
                  <span
                    class="fas"
                    :class="{
                      'fa-eye': !show.confirm_password,
                      'fa-eye-slash': show.confirm_password,
                    }"
                  ></span>
                </div>
              </div>
            </div>
            <div
              class="text-danger"
              v-if="
                $v.payload.confirm_password.$error &&
                !$v.payload.confirm_password.required
              "
            >
              <small>Confirm Password Required</small>
            </div>
            <div
              class="text-danger"
              v-if="!$v.payload.confirm_password.sameAsPassword"
            >
              <small>Password must be Identical</small>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <button
                type="submit"
                class="btn btn-danger btn-block mb-2 rounded-pill d-flex align-items-center justify-content-center"
                :disabled="submitStatus === 'PENDING'"
              >
              <div v-if="loading" class="spinner-border text-light me-2" role="status"></div>
                Register
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { required, sameAs, email, helpers } from "vuelidate/lib/validators";
import axios from "axios";
const checkData = helpers.regex("checkData", /^[0-9+ ]+$/);

export default {
  data() {
    return {
      resendId: null,
      payload: {
        name: "",
        username: "",
        email: "",
        phone: "",
        password: "",
        confirm_password: "",
      },
      show: {
        password: false,
        confirm_password: false,
      },
      phoneFirstTimeLoad: 0,
      phoneValid: null,
      submitStatus: null,
      loading: false,
      successMessage: null,
      errorMessage: {
        email: null,
        username: null,
      },
    };
  },
  validations: {
    payload: {
      name: {
        required,
      },
      username: {
        required,
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
        checkData,
      },
      password: {
        required,
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs("password"),
      },
    },
  },
  computed: {
    confirmationPath() {
      if ((process.env?.VUE_APP_PUBLIC_PATH ?? "").length > 0) {
        return `${
          window.location.origin + process.env.VUE_APP_PUBLIC_PATH
        }login/`;
      }
      return `${window.location.origin}/login/`;
    },
  },
  methods: {
    countryChanged(country) {
      let countryCode = country.dialCode;
      this.phoneFirstTimeLoad++;

      const myPromise = new Promise((resolve) => {
        resolve((this.payload.phone = ""));
      });

      myPromise.then(() => {
        this.payload.phone = `+${countryCode}`;
      });
    },
    validatePhone(country) {
      this.phoneValid = country.valid;
    },
    validateFirstLetter() {
      if (this.payload.phone[0] != "+") {
        this.phoneValid = false;
      }
    },
    showPassword() {
      this.show.password = !this.show.password;
    },
    showConfirmPassword() {
      this.show.confirm_password = !this.show.confirm_password;
    },
    async resendVerification(id) {
      try {
        let response = await axios.get(
          `${process.env.VUE_APP_VENDOR_BASE_URL}${id}/resend-email-verification/?verification_redirect_success=${this.confirmationPath}&verification_redirect_fail=${this.confirmationPath}`
        );
        this.successMessage = response.data.message
      } catch (error) {
        console.log(error);
      }
    },
    async register() {
      this.loading = true
      let data = new FormData();

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.loading = false
      } else {
        data.append("name", this.payload.name);
        data.append("username", this.payload.username);
        data.append("email", this.payload.email);
        data.append("phone", this.payload.phone);
        data.append("password", this.payload.password);

        this.submitStatus = "PENDING";
        try {
          let response = await axios.post(
            `${process.env.VUE_APP_VENDOR_BASE_URL}registration/?verification_redirect_success=${this.confirmationPath}&verification_redirect_fail=${this.confirmationPath}`,
            data
          );
          this.loading = false
          this.submitStatus = "OK";
          this.errorMessage.email = null;
          this.errorMessage.username = null;
          this.successMessage = response.data.message;
          this.resendId = response.data.data.id;
          this.$v.$reset();
          this.payload = {
            name: "",
            username: "",
            email: "",
            phone: "+93",
            password: "",
            confirm_password: "",
          };
          this.phoneFirstTimeLoad = 0;
        } catch (error) {
          this.loading = false
          this.submitStatus = "ERROR";
          this.successMessage = "";
          this.errorMessage = error.response.data.data;
        }
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  background-image: url("~@/assets/svg/wave.svg");
  background-size: cover;
  background-position: center;
}
.login-card-body {
  width: 350px !important;
  padding: 1.5rem 2rem;
}
@media (max-width: 325px) {
  .card,
  .login-card-body {
    width: 100% !important;
    border-radius: 0 !important;
  }
  .login-card-body {
    padding: 1rem !important;
  }
}
</style>